import Container from "../../../Components/Cards/Account/Container";
import SimpleGray from "../../../Components/Buttons/SimpleGray";
import GradientCustom from "../../../Components/Buttons/GradientCustom";

export default function CardAccount({
  account,
  user,
  accountType,
  isLoading,
  setIsLoading,
}) {
  return (
    <div className="w-full max-w-96 flex flex-col gap-2.5">
      <Container
        color="blue"
        account={account}
        user={user}
        setIsLoading={setIsLoading}
        accountType="live"
      />

      {!isLoading && account ? (
        account?.challenge_type === "real" ? (
          <GradientCustom
            text="معامله"
            href={`/trade/${account.code}/trade`}
            color="blue"
          />
        ) : (
          <SimpleGray text="معامله" href={`/trade/${account.code}/trade`} />
        )
      ) : null}
    </div>
  );
}
